// assets/pamela-cart-protect-addons.js
(function () {
  const DELIVERY_FEE_HANDLE = "delivery-fee";
  const DELIVERY_FEE_VARIANT_IDS = new Set([
    "47003100971235",
    "46964475494627",
    "46964475527395",
    "46964475560163",
    "46964475592931",
    "46964475625699",
    "46964475658467",
    "46964475691235",
    "46964475724003",
    "46964475756771",
    "46964475789539"
  ]);

  let latestRequiredAddonVariantIds = new Set();
  let latestEditorUrlByVariant = new Map();
  let latestCartItems = [];
  let protectRefreshTimer = null;
  let protectInFlight = null;
  let protectRendering = false;
  let protectObserver = null;
  let protectBindingsReady = false;
  let cartEditSelectionMode = false;
  const croppedThumbCache = new Map();

  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Could not load cart.");
    return await res.json();
  }

  function b64DecodeUnicode(s) {
    try {
      return decodeURIComponent(escape(atob(String(s || ""))));
    } catch (_) {
      return "";
    }
  }

  function decodeChunkedJson(props, baseKey) {
    try {
      const map = props || {};
      const count = Number(map[`${baseKey} Chunks`] || 0);
      if (!count) return null;
      let joined = "";
      for (let i = 1; i <= count; i += 1) {
        joined += String(map[`${baseKey} ${i}`] || "");
      }
      if (!joined) return null;
      const json = b64DecodeUnicode(joined);
      return json ? JSON.parse(json) : null;
    } catch (_) {
      return null;
    }
  }

  function cartItemElements() {
    const mainCart = document.querySelector("cart-items");
    if (mainCart) return Array.from(mainCart.querySelectorAll(".cart-item"));

    const drawer = document.querySelector("cart-drawer:not(.is-empty)") || document.querySelector("cart-drawer");
    if (drawer) return Array.from(drawer.querySelectorAll(".cart-item"));

    return Array.from(document.querySelectorAll(".cart__items .cart-item, .cart-items .cart-item"));
  }

  function findRemoveControls(itemEl) {
    const selectors = [
      'a[href*="cart/change"]',
      'a[href*="cart/update"]',
      'button[name="update"]',
      'button[aria-label*="Remove"]',
      'a[aria-label*="Remove"]',
      'cart-remove-button button',
      'cart-remove-button a',
      'button.cart-remove',
      'a.cart-remove'
    ];
    const out = [];
    selectors.forEach((sel) => itemEl.querySelectorAll(sel).forEach((n) => out.push(n)));
    return out;
  }

  function isDeliveryFeeItem(item) {
    if (!item) return false;
    return (
      String(item.handle || "").trim() === DELIVERY_FEE_HANDLE ||
      String(item.product_handle || "").trim() === DELIVERY_FEE_HANDLE ||
      DELIVERY_FEE_VARIANT_IDS.has(String(item.variant_id || "").trim())
    );
  }

  function getItemProps(item) {
    return item && item.properties ? item.properties : {};
  }

  function getLocalCartThumb(key) {
    try {
      const k = String(key || "").trim();
      if (!k) return "";
      return String(window.localStorage?.getItem(k) || "").trim();
    } catch (_) {
      return "";
    }
  }

  function getCartThumbFromProps(props, side) {
    const p = props && typeof props === "object" ? props : {};
    if (side === "back") {
      return String(p["_Back Thumb"] || "").trim() || getLocalCartThumb(p["_Back Thumb Local Key"]);
    }
    return (
      String(p["_Front Thumb"] || p["_Design Thumb"] || "").trim() ||
      getLocalCartThumb(p["_Front Thumb Local Key"])
    );
  }

  function getItemKey(item) {
    return String(item && item.key ? item.key : "").trim();
  }

  function getItemDesignId(item) {
    const props = getItemProps(item);
    return String(props._cm_design_id || "").trim();
  }

  function getItemParentDesignId(item) {
    const props = getItemProps(item);
    return String(props._cm_parent_design_id || "").trim();
  }

  function getFallbackAddonKind(item) {
    const title = String(
      item?.product_title ||
      item?.title ||
      item?.product?.title ||
      item?.handle ||
      ""
    ).toLowerCase();

    if (title.includes("laser etching") || title.includes("laser")) return "laser_etching";
    if (title.includes("porcelain portrait") || title.includes("porcelain")) return "porcelain_portrait";
    if (title.includes("additional word")) return "back_extra_word";
    if (title.includes("back engraving") || title.includes("lettering on back")) return "back_base";
    if (title.includes("decorative art")) return "back_decorative_art";
    if (title.includes("engraved panel")) return "back_engraved_panel";
    if (title.includes("vase") && title.includes("back")) return "vase_back";
    if (title.includes("vase") && title.includes("front")) return "vase_front";
    return "";
  }

  function isAddonItem(item) {
    const props = getItemProps(item);
    return (
      String(props._cm_addon || "").trim() === "required" ||
      String(props._cm_addon_kind || "").trim() !== "" ||
      getFallbackAddonKind(item) !== ""
    );
  }

  function isEmptyBackBaseAddon(itemOrProps) {
    const props = itemOrProps && itemOrProps.properties ? itemOrProps.properties : (itemOrProps || {});
    const kind = String(props._cm_addon_kind || "").trim();
    if (kind !== "back_base") return false;
    const lastName = String(props["_Back Last Name"] || "").trim();
    const inscription = String(props["_Back Inscription"] || "").trim();
    const words = Number(props["_Back Words"] || 0) || 0;
    return !lastName && !inscription && words <= 0;
  }

  function isMainDesignItem(item) {
    return !!getItemDesignId(item) && !isAddonItem(item);
  }

  function getAssociatedDeliveryFeeKeys(mainDesignId, items) {
    const taggedFeeKeys = (items || [])
      .filter((row) => {
        if (!isDeliveryFeeItem(row)) return false;
        const props = getItemProps(row);
        return (
          String(props._cm_parent_design_id || "").trim() === mainDesignId ||
          String(props._cm_design_id || "").trim() === mainDesignId
        );
      })
      .map((row) => row.key);

    if (taggedFeeKeys.length) return taggedFeeKeys;

    const mainDesignItems = (items || []).filter((row) => isMainDesignItem(row));
    if (mainDesignItems.length !== 1) return [];
    if (getItemDesignId(mainDesignItems[0]) !== mainDesignId) return [];

    return (items || []).filter((row) => isDeliveryFeeItem(row)).map((row) => row.key);
  }

  function hideRemoveControls(itemEl) {
    findRemoveControls(itemEl).forEach((btn) => {
      btn.style.display = "none";
      btn.setAttribute("aria-disabled", "true");
      btn.setAttribute("disabled", "disabled");
    });
  }

  async function clearCart() {
    const res = await fetch("/cart/clear.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      credentials: "same-origin"
    });
    if (!res.ok) throw new Error("Could not clear cart.");
  }

  function findCartHeaderAnchor() {
    return (
      document.querySelector(".title-wrapper-with-link") ||
      document.querySelector(".main-cart-title") ||
      document.querySelector(".title--primary")?.parentElement ||
      document.querySelector("main .page-width")
    );
  }

  function ensureCartHeaderActions() {
    const anchor = findCartHeaderAnchor();
    if (!anchor) return;

    let actions = document.getElementById("pamela-cart-header-actions");
    if (!actions) {
      actions = document.createElement("div");
      actions.id = "pamela-cart-header-actions";
      actions.className = "pamela-cart-header-actions";
    }

    if (actions.parentElement !== anchor) anchor.appendChild(actions);
    return actions;
  }

  function upsertEmptyCartButton() {
    const actions = ensureCartHeaderActions();
    if (!actions) return;

    let btn = document.getElementById("pamela-empty-cart-btn");
    if (!btn) {
      btn = document.createElement("button");
      btn.type = "button";
      btn.id = "pamela-empty-cart-btn";
      btn.textContent = "Empty cart";
      btn.className = "pamela-cart-header-btn pamela-cart-header-btn--dark";
    }

    if (btn.parentElement !== actions) actions.appendChild(btn);
  }

  function updateCartEditControlFromSelection() {
    const btn = document.getElementById("pamela-cart-edit-design-btn");
    if (!btn || btn.dataset.mode !== "multi") return;

    const selected = document.querySelector(".pamela-design-select-input:checked");
    const url = String(selected?.dataset.editUrl || "").trim();
    if (url) {
      btn.href = url;
      btn.textContent = "Edit selected design";
      btn.setAttribute("aria-disabled", "false");
      btn.classList.remove("is-disabled");
    } else {
      btn.removeAttribute("href");
      btn.textContent = cartEditSelectionMode ? "Select a design" : "Edit design";
      btn.setAttribute("aria-disabled", cartEditSelectionMode ? "true" : "false");
      btn.classList.toggle("is-disabled", cartEditSelectionMode);
    }
  }

  function upsertCartEditControl(editableDesigns) {
    const actions = ensureCartHeaderActions();
    const designs = Array.isArray(editableDesigns)
      ? editableDesigns.filter((design) => String(design?.editUrl || "").trim())
      : [];

    let wrap = document.getElementById("pamela-cart-edit-toolbar");
    if (!designs.length || !actions) {
      if (wrap) wrap.remove();
      return;
    }

    if (!wrap) {
      wrap = document.createElement("div");
      wrap.id = "pamela-cart-edit-toolbar";
      wrap.className = "pamela-cart-edit-toolbar";
      wrap.innerHTML =
        '<a id="pamela-cart-edit-design-btn" class="pamela-cart-header-btn pamela-cart-header-btn--dark">Edit design</a>' +
        '<span class="pamela-cart-edit-toolbar-text"></span>';
    }

    const emptyBtn = document.getElementById("pamela-empty-cart-btn");
    if (emptyBtn && emptyBtn.parentElement === actions) {
      actions.insertBefore(wrap, emptyBtn);
    } else if (wrap.parentElement !== actions) {
      actions.appendChild(wrap);
    }

    const btn = wrap.querySelector("#pamela-cart-edit-design-btn");
    const note = wrap.querySelector(".pamela-cart-edit-toolbar-text");

    if (designs.length === 1) {
      cartEditSelectionMode = false;
      btn.dataset.mode = "single";
      btn.dataset.editUrl = designs[0].editUrl;
      btn.href = designs[0].editUrl;
      btn.textContent = "Edit design";
      btn.setAttribute("aria-disabled", "false");
      btn.classList.remove("is-disabled");
      note.textContent = "Need changes before checkout?";
      return;
    }

    btn.dataset.mode = "multi";
    delete btn.dataset.editUrl;
    btn.removeAttribute("href");
    btn.textContent = cartEditSelectionMode ? "Select a design" : "Edit design";
    btn.setAttribute("aria-disabled", "false");
    btn.classList.remove("is-disabled");
    note.textContent = cartEditSelectionMode
      ? "Choose the design row you want to edit."
      : "Need changes before checkout?";
    updateCartEditControlFromSelection();
  }

  async function removeLineItemKeys(keys) {
    const uniqueKeys = Array.from(new Set((keys || []).map((k) => String(k || "").trim()).filter(Boolean)));
    if (!uniqueKeys.length) return;
    const updates = {};
    uniqueKeys.forEach((key) => {
      updates[key] = 0;
    });

    const res = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({ updates: updates })
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error(txt || "Could not update cart.");
    }
  }

  function ensureCartStyles() {
    if (document.getElementById("pamela-cart-protect-styles")) return;

    const style = document.createElement("style");
    style.id = "pamela-cart-protect-styles";
    style.textContent = [
      ".pamela-cart-header-actions{display:flex;flex-wrap:wrap;align-items:center;justify-content:flex-end;gap:10px;margin-left:auto;}",
      ".pamela-cart-header-btn{display:inline-flex;align-items:center;justify-content:center;min-height:38px;padding:8px 14px;border-radius:999px;border:none;text-decoration:none;cursor:pointer;font:700 13px/1 system-ui,-apple-system,Segoe UI,Roboto,Arial;}",
      ".pamela-cart-header-btn--dark{background:#111;color:#fff;}",
      ".pamela-cart-header-btn.is-disabled{opacity:.45;cursor:not-allowed;pointer-events:none;}",
      ".pamela-cart-edit-toolbar{display:inline-flex;align-items:center;gap:10px;}",
      ".pamela-cart-edit-toolbar-text{max-width:220px;font:600 12px/1.35 system-ui,-apple-system,Segoe UI,Roboto,Arial;color:#555;}",
      ".pamela-design-select-wrap{display:inline-flex;align-items:center;gap:8px;margin:0 0 8px;font:700 12px/1.2 system-ui,-apple-system,Segoe UI,Roboto,Arial;color:#333;}",
      ".pamela-design-select-input{width:18px;height:18px;margin:0;accent-color:#111;}",
      ".cart-item__media{width:20rem!important;max-width:20rem!important;background:transparent!important;}",
      ".cart-item__image-container{width:18rem!important;height:14rem!important;max-width:18rem!important;aspect-ratio:auto!important;display:flex!important;align-items:center!important;justify-content:center!important;overflow:hidden!important;background:transparent!important;}",
      ".cart-item__image{width:100%!important;height:100%!important;max-width:100%!important;object-fit:contain!important;object-position:center center!important;background:transparent!important;}",
      ".cart-item__image.cm-main-design-thumb{transform:none!important;transform-origin:center center;}",
      ".cart-item__image.cm-addon-specific-thumb,.cart-item__image.cm-portrait-thumb{transform:scale(1.18)!important;transform-origin:center center;}",
      ".cart-item__image.cm-back-design-thumb{transform:none!important;transform-origin:center center;}",
      ".cart-item__nested-line .cart-item__image-container{min-width:18rem!important;justify-content:center!important;}",
      ".cart-item__nested-line .cart-item__image-container img{width:100%!important;height:100%!important;object-fit:contain!important;}",
      ".cart-drawer .cart-item__media{width:12rem!important;max-width:12rem!important;}",
      ".cart-drawer .cart-item__image-container{width:11rem!important;height:8.5rem!important;max-width:11rem!important;}",
      ".cart-item__error:has(.cart-item__error-text:empty){display:none!important;}",
      ".pamela-cart-remove-mount{display:inline-flex;flex-direction:column;align-items:flex-start;gap:8px;margin-left:12px;vertical-align:middle;max-width:240px;}",
      ".pamela-cart-edit-wrap{display:flex;flex-wrap:wrap;gap:8px;align-items:center;max-width:240px;}",
      ".pamela-cart-edit-text{font:600 12px/1.35 system-ui,-apple-system,Segoe UI,Roboto,Arial;color:#555;}",
      ".pamela-addon-note{margin-top:4px;font:600 12px/1.35 system-ui,-apple-system,Segoe UI,Roboto,Arial;color:#666;}",
      ".cart-item.cm-required-addon .cart-item__quantity quantity-popover{display:none!important;}",
      ".cart-item.cm-required-addon .cart-item__quantity::before{content:'Qty 1';display:inline-flex;min-height:38px;align-items:center;font:600 13px/1 system-ui,-apple-system,Segoe UI,Roboto,Arial;color:#555;}",
      ".cart-drawer .cart-item.cm-required-addon .cart-item__quantity::before{min-height:30px;}",
      "@media (max-width: 989px){",
      "  .pamela-cart-header-actions{width:100%;justify-content:flex-start;margin:12px 0 0;}",
      "  .pamela-cart-edit-toolbar{flex-wrap:wrap;}",
      "  .pamela-cart-remove-mount{display:flex;width:100%;max-width:none;margin:10px 0 0;}",
      "  .pamela-cart-edit-wrap{max-width:none;width:100%;}",
      "}"
    ].join("");
    document.head.appendChild(style);
  }

  function findActionMount(itemEl) {
    if (!itemEl) return null;

    const removeControls = findRemoveControls(itemEl);
    const removeEl = removeControls[0];
    if (removeEl) {
      let mount = itemEl.querySelector(".pamela-cart-remove-mount");
      if (!mount) {
        mount = document.createElement("div");
        mount.className = "pamela-cart-remove-mount";
      }

      const host =
        removeEl.closest("cart-remove-button") ||
        removeEl.parentElement ||
        removeEl;

      const parent = host.parentElement;
      if (parent && mount.parentElement !== parent) {
        parent.insertBefore(mount, host.nextSibling);
      } else if (!mount.parentElement) {
        itemEl.appendChild(mount);
      }

      return mount;
    }

    return (
      itemEl.querySelector(".cart-item__details") ||
      itemEl.querySelector(".cart-item__name")?.parentElement ||
      itemEl.querySelector(".product-option")?.parentElement ||
      itemEl
    );
  }

  function upsertEditButton(itemEl, editUrl, noteText) {
    const url = String(editUrl || "").trim();
    if (!url) return;
    const mount = findActionMount(itemEl) || itemEl;

    let wrap = itemEl.querySelector(".pamela-cart-edit-wrap");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "pamela-cart-edit-wrap";
      mount.appendChild(wrap);
    } else if (wrap.parentElement !== mount) {
      mount.appendChild(wrap);
    }

    let btn = wrap.querySelector(".pamela-cart-edit-btn");
    if (!btn) {
      btn = document.createElement("a");
      btn.className = "pamela-cart-edit-btn";
      btn.textContent = "Edit design";
      btn.style.cssText =
        "display:inline-flex;align-items:center;justify-content:center;min-height:38px;" +
        "padding:8px 14px;border-radius:999px;background:#111;color:#fff;text-decoration:none;" +
        "font:700 13px/1 system-ui,-apple-system,Segoe UI,Roboto,Arial;";
      wrap.appendChild(btn);
    }
    btn.href = url;

    if (noteText) {
      let note = wrap.querySelector(".pamela-cart-edit-text");
      if (!note) {
        note = document.createElement("div");
        note.className = "pamela-cart-edit-text";
        wrap.appendChild(note);
      }
      note.textContent = noteText;
    }
  }

  function removeEditButton(itemEl) {
    const wrap = itemEl.querySelector(".pamela-cart-edit-wrap");
    if (wrap) wrap.remove();
  }

  function removeDesignSelector(itemEl) {
    const selector = itemEl && itemEl.querySelector(".pamela-design-select-wrap");
    if (selector) selector.remove();
    if (itemEl) {
      itemEl.classList.remove("cm-editable-design");
      itemEl.removeAttribute("data-cm-edit-url");
    }
  }

  function removeAddonNote(itemEl) {
    const note = itemEl && itemEl.querySelector(".pamela-addon-note");
    if (note) note.remove();
  }

  function decorateRequiredAddonItem(itemEl, editUrl) {
    const mount =
      itemEl.querySelector(".cart-item__details") ||
      findActionMount(itemEl) ||
      itemEl;
    itemEl.classList.add("cm-required-addon");
    hideRemoveControls(itemEl);

    if (!itemEl.querySelector(".pamela-addon-note")) {
      const note = document.createElement("div");
      note.className = "pamela-addon-note";
      note.textContent = "Included with design.";
      mount.appendChild(note);
    } else if (itemEl.querySelector(".pamela-addon-note").parentElement !== mount) {
      mount.appendChild(itemEl.querySelector(".pamela-addon-note"));
    }

    removeEditButton(itemEl);
    removeDesignSelector(itemEl);
  }

  function decorateEditableMainItem(itemEl, designId, editUrl, showSelector) {
    removeEditButton(itemEl);
    itemEl.classList.add("cm-editable-design");
    itemEl.setAttribute("data-cm-edit-url", editUrl);

    if (!showSelector) {
      removeDesignSelector(itemEl);
      return;
    }

    const details = itemEl.querySelector(".cart-item__details") || itemEl;
    const name = details.querySelector(".cart-item__name");
    let wrap = itemEl.querySelector(".pamela-design-select-wrap");
    if (!wrap) {
      wrap = document.createElement("label");
      wrap.className = "pamela-design-select-wrap";
      wrap.innerHTML =
        '<input class="pamela-design-select-input" type="checkbox">' +
        '<span>Select to edit</span>';
    }

    const input = wrap.querySelector(".pamela-design-select-input");
    input.value = designId;
    input.dataset.editUrl = editUrl;
    input.setAttribute("aria-label", "Select this design to edit");

    if (wrap.parentElement !== details) {
      if (name) details.insertBefore(wrap, name);
      else details.insertBefore(wrap, details.firstChild);
    }
  }

  function findPrimaryCartImage(itemEl) {
    if (!itemEl) return null;
    const selectors = [
      ".cart-item__media img",
      ".cart-item__image img",
      ".cart-item img",
      "img"
    ];
    for (const sel of selectors) {
      const img = itemEl.querySelector(sel);
      if (img) return img;
    }
    return null;
  }

  function ensurePrimaryCartImage(itemEl) {
    const existing = findPrimaryCartImage(itemEl);
    if (existing) return existing;

    const host =
      itemEl.querySelector(".cart-item__media") ||
      itemEl.querySelector(".cart-item__image") ||
      itemEl.querySelector(".cart-item__media-wrapper");

    if (!host) return null;

    const img = document.createElement("img");
    img.alt = "";
    img.loading = "lazy";
    img.style.cssText = "width:100%;height:100%;display:block;object-fit:contain;object-position:center center;background:transparent;";
    host.appendChild(img);
    return img;
  }

  function ensureThumbHost(img) {
    if (!img) return null;
    const host =
      img.closest(".cart-item__image-container") ||
      img.closest(".cart-drawer .cart-item__media") ||
      img.parentElement;
    if (!host) return null;

    const styles = window.getComputedStyle(host);
    if (styles.position === "static") {
      host.style.position = "relative";
    }
    host.style.width = host.closest?.(".cart-drawer") ? "11rem" : "18rem";
    host.style.height = host.closest?.(".cart-drawer") ? "8.5rem" : "14rem";
    host.style.maxWidth = host.closest?.(".cart-drawer") ? "11rem" : "18rem";
    host.style.display = "flex";
    host.style.alignItems = "center";
    host.style.justifyContent = "center";
    host.style.overflow = "hidden";
    host.style.background = "transparent";
    return host;
  }

  function cropDarkPaddingFromThumb(thumbUrl, callback) {
    const url = String(thumbUrl || "").trim();
    if (!url) {
      callback("");
      return;
    }
    if (croppedThumbCache.has(url)) {
      callback(croppedThumbCache.get(url));
      return;
    }

    const source = new Image();
    source.onload = function () {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = source.naturalWidth || source.width;
        canvas.height = source.naturalHeight || source.height;
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        if (!ctx || !canvas.width || !canvas.height) {
          callback(url);
          return;
        }

        ctx.drawImage(source, 0, 0);
        const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        const samplePixel = function (x, y) {
          const i = (y * canvas.width + x) * 4;
          return [data[i], data[i + 1], data[i + 2], data[i + 3]];
        };
        const corners = [
          samplePixel(0, 0),
          samplePixel(canvas.width - 1, 0),
          samplePixel(0, canvas.height - 1),
          samplePixel(canvas.width - 1, canvas.height - 1)
        ];
        const bg = corners.reduce(
          function (sum, px) {
            sum[0] += px[0];
            sum[1] += px[1];
            sum[2] += px[2];
            sum[3] += px[3];
            return sum;
          },
          [0, 0, 0, 0]
        ).map(function (v) {
          return v / corners.length;
        });
        const cornerSpread = corners.reduce(function (max, px) {
          const delta =
            Math.abs(px[0] - bg[0]) +
            Math.abs(px[1] - bg[1]) +
            Math.abs(px[2] - bg[2]) +
            Math.abs(px[3] - bg[3]);
          return Math.max(max, delta);
        }, 0);
        const hasUniformBackground = cornerSpread < 54;
        const differsFromBg = function (r, g, b, a) {
          if (a <= 20) return false;
          if (!hasUniformBackground) return true;
          const delta =
            Math.abs(r - bg[0]) +
            Math.abs(g - bg[1]) +
            Math.abs(b - bg[2]) +
            Math.abs(a - bg[3]);
          return delta > 44;
        };

        let top = canvas.height;
        let left = canvas.width;
        let right = -1;
        let bottom = -1;

        for (let y = 0; y < canvas.height; y += 1) {
          for (let x = 0; x < canvas.width; x += 1) {
            const i = (y * canvas.width + x) * 4;
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const a = data[i + 3];
            const isVisible = differsFromBg(r, g, b, a);
            if (!isVisible) continue;

            if (x < left) left = x;
            if (x > right) right = x;
            if (y < top) top = y;
            if (y > bottom) bottom = y;
          }
        }

        if (right <= left || bottom <= top) {
          callback(url);
          return;
        }

        const padX = Math.max(2, Math.round((right - left + 1) * 0.03));
        const padY = Math.max(2, Math.round((bottom - top + 1) * 0.03));
        const cropX = Math.max(0, left - padX);
        const cropY = Math.max(0, top - padY);
        const cropW = Math.min(canvas.width - cropX, right - left + 1 + padX * 2);
        const cropH = Math.min(canvas.height - cropY, bottom - top + 1 + padY * 2);

        const out = document.createElement("canvas");
        out.width = cropW;
        out.height = cropH;
        const outCtx = out.getContext("2d");
        if (!outCtx) {
          callback(url);
          return;
        }

        outCtx.drawImage(canvas, cropX, cropY, cropW, cropH, 0, 0, cropW, cropH);
        const cropped = out.toDataURL("image/png");
        croppedThumbCache.set(url, cropped);
        callback(cropped);
      } catch (_) {
        croppedThumbCache.set(url, url);
        callback(url);
      }
    };
    source.onerror = function () {
      croppedThumbCache.set(url, url);
      callback(url);
    };
    source.src = url;
  }

  function clearBackThumbBadge(itemEl) {
    const img = findPrimaryCartImage(itemEl);
    const host = ensureThumbHost(img);
    if (!img || !host) return;
    const badge = host.querySelector(".pamela-back-thumb-badge");
    if (badge) badge.remove();
  }

  function applyThumbnailToItem(itemEl, thumbUrl, options) {
    if (!itemEl) return;

    const img = ensurePrimaryCartImage(itemEl);
    if (!img || !thumbUrl) return;

    const host = ensureThumbHost(img);

    const finalUrl = String(thumbUrl || "").trim();
    window.requestAnimationFrame(function () {
      if (!finalUrl) return;
      img.classList.toggle("cm-addon-specific-thumb", !!(options && options.specificAsset));
      img.classList.toggle("cm-main-design-thumb", !!(options && options.mainDesign));
      img.classList.toggle("cm-back-design-thumb", !!(options && options.backDesign));
      img.classList.toggle("cm-portrait-thumb", !!(options && options.portraitThumb));
      if (img.dataset.cmThumbSrc !== finalUrl) {
        img.dataset.cmThumbSrc = finalUrl;
        img.src = finalUrl;
      }
      if (img.srcset) img.srcset = "";
      img.removeAttribute("srcset");
      img.style.width = "100%";
      img.style.height = "100%";
      img.style.maxWidth = "100%";
      img.style.display = "block";
      img.style.objectFit = (options && options.objectFit) || "contain";
      img.style.objectPosition = (options && options.objectPosition) || "center center";
      img.style.background = "transparent";
      img.style.transformOrigin = "center center";
      if (host) {
        host.style.width = host.closest?.(".cart-drawer") ? "11rem" : "18rem";
        host.style.height = host.closest?.(".cart-drawer") ? "8.5rem" : "14rem";
        host.style.maxWidth = host.closest?.(".cart-drawer") ? "11rem" : "18rem";
        host.style.display = "flex";
        host.style.alignItems = "center";
        host.style.justifyContent = "center";
        host.style.overflow = "hidden";
        host.style.background = "transparent";
      }
    });
  }

  function decorateMainThumbnail(itemEl, item) {
    if (!itemEl || !item) return;

    const props = item.properties || {};
    const frontThumb = getCartThumbFromProps(props, "front");
    cropDarkPaddingFromThumb(frontThumb, function (croppedThumb) {
      applyThumbnailToItem(itemEl, croppedThumb || frontThumb, {
        objectFit: "contain",
        objectPosition: "center center",
        mainDesign: true
      });
    });
    clearBackThumbBadge(itemEl);
  }

  function decorateAddonThumbnail(itemEl, thumbUrl, isSpecificAsset, options) {
    const backDesign = !!(options && options.backDesign);
    const portraitThumb = !!(options && options.portraitThumb);
    if (isSpecificAsset) {
      cropDarkPaddingFromThumb(thumbUrl, function (croppedThumb) {
        applyThumbnailToItem(itemEl, croppedThumb || thumbUrl, {
          objectFit: "contain",
          objectPosition: "center center",
          specificAsset: true,
          portraitThumb: portraitThumb
        });
      });
    } else {
      cropDarkPaddingFromThumb(thumbUrl, function (croppedThumb) {
        applyThumbnailToItem(itemEl, croppedThumb || thumbUrl, {
          objectFit: "contain",
          objectPosition: "center center",
          mainDesign: !backDesign,
          backDesign: backDesign
        });
      });
    }
    clearBackThumbBadge(itemEl);
  }

  function getAddonMeta(item, recipeByDesignId) {
    const p = item && item.properties ? item.properties : {};
    const variantId = String(item && item.variant_id != null ? item.variant_id : "").trim();
    const explicitParentDesignId = String(p._cm_parent_design_id || "").trim();
    const explicitKind = String(p._cm_addon_kind || "").trim();

    if (explicitParentDesignId) {
      return {
        parentDesignId: explicitParentDesignId,
        kind: explicitKind
      };
    }

    if (String(p._cm_addon || "").trim() === "required") {
      return {
        parentDesignId: explicitParentDesignId,
        kind: explicitKind
      };
    }

    if (!variantId || !(recipeByDesignId instanceof Map)) return null;

    for (const [designId, recipe] of recipeByDesignId.entries()) {
      if (!Array.isArray(recipe)) continue;
      const match = recipe.find((entry) => String(entry && entry.id != null ? entry.id : "").trim() === variantId);
      if (!match) continue;
      const props = (match && match.properties) || {};
      return {
        parentDesignId: String(props._cm_parent_design_id || designId || "").trim(),
        kind: String(props._cm_addon_kind || "").trim()
      };
    }

    return null;
  }

  function getKnownAddonMeta(item, recipeByDesignId, fallbackParentDesignId) {
    const props = getItemProps(item);
    const fallbackParent = String(fallbackParentDesignId || "").trim();
    const rowParentDesignId = String(props._cm_parent_design_id || "").trim();
    const rowKind = String(props._cm_addon_kind || "").trim();

    if (rowParentDesignId || rowKind) {
      return {
        parentDesignId: rowParentDesignId || fallbackParent,
        kind: rowKind || getFallbackAddonKind(item),
        inferredParent: !rowParentDesignId && !!fallbackParent
      };
    }

    const recipeMeta = getAddonMeta(item, recipeByDesignId);
    if (recipeMeta && (recipeMeta.parentDesignId || recipeMeta.kind)) {
      if (!recipeMeta.parentDesignId && fallbackParent) {
        return {
          ...recipeMeta,
          parentDesignId: fallbackParent,
          inferredParent: true
        };
      }
      return recipeMeta;
    }

    const kind = getFallbackAddonKind(item);
    if (kind) {
      return {
        parentDesignId: fallbackParent,
        kind: kind,
        inferred: true
      };
    }

    return null;
  }

  function getAddonSide(item, addonKind) {
    const props = getItemProps(item);
    const kind = String(addonKind || props._cm_addon_kind || "").trim();
    const explicitSide = String(props._cm_addon_side || "").trim().toLowerCase();
    const laserSide = String(props["Laser Side"] || "").trim().toLowerCase();

    if (explicitSide === "front" || explicitSide === "back") return explicitSide;
    if (laserSide === "front" || laserSide === "back") return laserSide;

    if (
      kind === "back_base" ||
      kind === "back_extra_word" ||
      kind === "back_decorative_art" ||
      kind === "back_engraved_panel" ||
      kind === "vase_back"
    ) {
      return "back";
    }

    if (kind === "vase_front") return "front";
    if (kind.indexOf("laser_") === 0 || kind === "laser_etching") return "front";
    if (kind === "porcelain_portrait") return "front";
    return "";
  }

  function getAddonSideRank(item, addonKind) {
    const side = getAddonSide(item, addonKind);
    if (side === "front") return 10;
    if (side === "back") return 20;
    return 30;
  }

  function getAddonSortRank(item, addonKind) {
    const kind = String(addonKind || "").trim();
    if (kind === "back_base") return 5;
    if (kind === "back_extra_word") return 6;
    if (kind.indexOf("laser_") === 0 || kind === "laser_etching") return 10;
    if (kind === "porcelain_portrait") return 20;
    if (
      kind === "back_decorative_art" ||
      kind === "back_engraved_panel"
    ) {
      return 30;
    }
    if (kind === "vase_front" || kind === "vase_back") return 40;
    if (isDeliveryFeeItem(item)) return 90;
    return 50;
  }

  function getAddonThumbnailSide(item, addonKind) {
    const props = getItemProps(item);
    const kind = String(addonKind || "").trim();
    const addonSide = getAddonSide(item, kind);
    if (kind.indexOf("laser_") === 0 || kind === "laser_etching") return addonSide === "back" ? "back" : "front";

    if (
      kind === "back_base" ||
      kind === "back_extra_word" ||
      kind === "back_decorative_art" ||
      kind === "back_engraved_panel" ||
      kind === "vase_back"
    ) {
      return "back";
    }

    return "front";
  }

  function getAddonSpecificThumbnail(item, addonKind) {
    const props = getItemProps(item);
    const kind = String(addonKind || "").trim();

    if (kind.indexOf("laser_") === 0 || kind === "laser_etching") {
      return String(props["_Laser Thumb"] || "").trim();
    }

    if (kind === "porcelain_portrait") {
      return String(
        props["_Portrait Thumb"] ||
        props["Portrait Image"] ||
        props["Portrait Artwork"] ||
        ""
      ).trim();
    }

    return "";
  }

  function applyGroupedCartOrder(rowEntries, metaByKey) {
    if (!Array.isArray(rowEntries) || !rowEntries.length) return;

    const tbody = rowEntries[0]?.el?.parentElement;
    if (!tbody) return;

    const entries = rowEntries.map((entry, index) => ({ ...entry, originalIndex: index }));
    const mainEntries = entries.filter(({ item }) => isMainDesignItem(item));
    if (!mainEntries.length) return;

    const used = new Set();
    const ordered = [];

    mainEntries.forEach((mainEntry) => {
      const mainDesignId = getItemDesignId(mainEntry.item);
      ordered.push(mainEntry);
      used.add(mainEntry);

      const children = entries
        .filter((entry) => {
          if (used.has(entry) || entry === mainEntry) return false;
          const meta = metaByKey.get(getItemKey(entry.item)) || null;
          const parentDesignId =
            (meta && meta.parentDesignId) ||
            getItemParentDesignId(entry.item) ||
            "";
          return parentDesignId === mainDesignId;
        })
        .sort((a, b) => {
          const aMeta = metaByKey.get(getItemKey(a.item)) || {};
          const bMeta = metaByKey.get(getItemKey(b.item)) || {};
          const sideDiff = getAddonSideRank(a.item, aMeta.kind) - getAddonSideRank(b.item, bMeta.kind);
          if (sideDiff) return sideDiff;
          const rankDiff = getAddonSortRank(a.item, aMeta.kind) - getAddonSortRank(b.item, bMeta.kind);
          return rankDiff || (a.originalIndex - b.originalIndex);
        });

      children.forEach((child) => {
        ordered.push(child);
        used.add(child);
      });
    });

    entries.forEach((entry) => {
      if (!used.has(entry)) ordered.push(entry);
    });

    ordered.forEach(({ el }) => {
      if (el && el.parentElement === tbody) tbody.appendChild(el);
    });
  }

  async function restoreMissingRequiredAddons(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const additions = [];

    items.forEach((it) => {
      const props = it && it.properties ? it.properties : {};
      const designId = String(props._cm_design_id || "").trim();
      if (!designId) return;

      const recipe = decodeChunkedJson(props, "_CM Required Addons");
      if (!Array.isArray(recipe) || !recipe.length) return;

      recipe.forEach((entry) => {
        const expectedId = Number(entry && entry.id);
        const expectedQty = Math.max(1, Number(entry && entry.quantity) || 1);
        const expectedProps = (entry && entry.properties) || {};
        const expectedKind = String(expectedProps._cm_addon_kind || "").trim();

        if (!expectedId || !expectedKind) return;
        if (isEmptyBackBaseAddon(expectedProps)) return;

        const actualQty = items
          .filter((row) => {
            const rowProps = row && row.properties ? row.properties : {};
            return (
              Number(row.variant_id) === expectedId &&
              String(rowProps._cm_parent_design_id || "").trim() === designId &&
              String(rowProps._cm_addon_kind || "").trim() === expectedKind
            );
          })
          .reduce((sum, row) => sum + Math.max(0, Number(row.quantity) || 0), 0);

        if (actualQty >= expectedQty) return;

        additions.push({
          id: expectedId,
          quantity: expectedQty - actualQty,
          properties: expectedProps
        });
      });
    });

    if (!additions.length) return false;

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        items: additions.map((it) => ({
          id: Number(it.id),
          quantity: Number(it.quantity || 1),
          properties: it.properties || {}
        }))
      })
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error(txt || "Could not restore required add-ons.");
    }

    return true;
  }

  function scheduleProtect(delay) {
    const wait = Math.max(0, Number(delay || 0) || 0);
    if (protectRefreshTimer) window.clearTimeout(protectRefreshTimer);
    protectRefreshTimer = window.setTimeout(() => {
      protectRefreshTimer = null;
      protectOnce().catch((e) => console.warn("pamela-cart-protect:", e));
    }, wait);
  }

  function scheduleProtectSeries(delays) {
    const list = Array.isArray(delays) ? delays : [delays];
    const wait = list.reduce((max, delay) => Math.max(max, Number(delay || 0) || 0), 0);
    scheduleProtect(wait);
  }

  function ensureProtectBindings() {
    if (protectBindingsReady) return;
    protectBindingsReady = true;

    ["click", "input"].forEach((eventName) => {
      document.addEventListener(
        eventName,
        (e) => {
          if (!e.target.closest(".pamela-design-select-input, .pamela-design-select-wrap")) return;
          e.stopPropagation();
        },
        true
      );
    });

    document.addEventListener(
      "click",
      (e) => {
        const removeEl = e.target.closest(
          'a[href*="/cart/change"], a[href*="cart/change"], button[aria-label*="Remove"], a[aria-label*="Remove"], cart-remove-button button, cart-remove-button a, button.cart-remove, a.cart-remove'
        );
        if (!removeEl) return;

        const itemEl = removeEl.closest(".cart-item");
        if (!itemEl) {
          scheduleProtectSeries([120, 400, 900, 1800]);
          return;
        }

        const variantId =
          itemEl.getAttribute("data-variant-id") ||
          itemEl.querySelector("[data-variant-id]")?.getAttribute("data-variant-id") ||
          "";

        if (variantId && latestRequiredAddonVariantIds.has(String(variantId))) {
          e.preventDefault();
          e.stopPropagation();
          const url = latestEditorUrlByVariant.get(String(variantId)) || "/";
          alert("This add-on comes from your design. Please return to the editor to remove it.");
          window.location.href = url;
          return;
        }

        const mainDesignId = String(itemEl.getAttribute("data-cm-design-id") || "").trim();
        const isMainDesign = String(itemEl.getAttribute("data-cm-main-design") || "") === "1";
        if (mainDesignId && isMainDesign) {
          e.preventDefault();
          e.stopPropagation();

          const associatedDeliveryFeeKeys = getAssociatedDeliveryFeeKeys(mainDesignId, latestCartItems);
          const keysToRemove = latestCartItems
            .filter((row) => {
              return (
                getItemDesignId(row) === mainDesignId ||
                getItemParentDesignId(row) === mainDesignId
              );
            })
            .map((row) => row.key)
            .concat(associatedDeliveryFeeKeys);

          removeLineItemKeys(keysToRemove)
            .then(() => {
              window.location.href = "/cart";
            })
            .catch((err) => {
              console.warn("pamela-cart cascade remove:", err);
              scheduleProtectSeries([120, 400, 900, 1800]);
            });
          return;
        }

        scheduleProtectSeries([120, 400, 900, 1800]);
      },
      true
    );

    document.addEventListener("change", (e) => {
      const designSelect = e.target.closest(".pamela-design-select-input");
      if (designSelect) {
        if (designSelect.checked) {
          document.querySelectorAll(".pamela-design-select-input").forEach((input) => {
            if (input !== designSelect) input.checked = false;
          });
          const url = String(designSelect.dataset.editUrl || "").trim();
          if (url) {
            window.location.href = url;
            return;
          }
        }
        updateCartEditControlFromSelection();
        return;
      }

      if (!e.target.closest('input[name="updates[]"], .quantity__input, quantity-input input')) return;
      scheduleProtectSeries([150, 500, 1000]);
    });

    document.addEventListener("click", (e) => {
      const btn = e.target.closest("#pamela-cart-edit-design-btn");
      if (!btn) return;
      if (btn.dataset.mode === "single") {
        const url = String(
          btn.getAttribute("href") ||
          btn.dataset.editUrl ||
          document.querySelector("[data-cm-edit-url]")?.getAttribute("data-cm-edit-url") ||
          ""
        ).trim();
        if (url) {
          e.preventDefault();
          window.location.href = url;
          return;
        }
      }
      if (btn.dataset.mode === "multi" && !cartEditSelectionMode) {
        e.preventDefault();
        cartEditSelectionMode = true;
        scheduleProtect(0);
        return;
      }
      if (btn.getAttribute("aria-disabled") === "true" || !String(btn.getAttribute("href") || "").trim()) {
        e.preventDefault();
      }
    });

    document.addEventListener("click", (e) => {
      const btn = e.target.closest("#pamela-empty-cart-btn");
      if (!btn) return;
      e.preventDefault();
      btn.setAttribute("disabled", "disabled");
      clearCart()
        .then(() => {
          window.location.href = "/cart";
        })
        .catch((err) => {
          console.warn("pamela-cart empty:", err);
          btn.removeAttribute("disabled");
        });
    });

    const observeTarget = document.body || document.documentElement;
    if (observeTarget && !protectObserver) {
      protectObserver = new MutationObserver(() => {
        if (protectRendering) return;
        scheduleProtect(250);
      });
      protectObserver.observe(observeTarget, { childList: true, subtree: true });
    }
  }

  async function protectOnce() {
    if (protectInFlight) return protectInFlight;
    protectInFlight = protectOnceInner();
    try {
      return await protectInFlight;
    } finally {
      protectInFlight = null;
    }
  }

  async function protectOnceInner() {
    const cart = await fetchCart();
    const initialItems = Array.isArray(cart && cart.items) ? cart.items : [];
    const emptyBackBaseKeys = initialItems
      .filter((item) => isEmptyBackBaseAddon(item))
      .map((item) => item && item.key)
      .filter(Boolean);
    if (emptyBackBaseKeys.length) {
      await removeLineItemKeys(emptyBackBaseKeys).catch((e) => {
        console.warn("pamela-cart cleanup empty back engraving:", e);
      });
      scheduleProtectSeries([150, 500, 1000]);
      return;
    }

    const restored = await restoreMissingRequiredAddons(cart).catch((e) => {
      console.warn("pamela-cart-protect restore:", e);
      return false;
    });
    if (restored) {
      scheduleProtectSeries([150, 500, 1000]);
      return;
    }

    const requiredAddonVariantIds = new Set();
    const editUrlByDesignId = new Map();
    const editorUrlByVariant = new Map();
    const thumbsByDesignId = new Map();
    const backThumbByDesignId = new Map();
    const recipeByDesignId = new Map();
    const items = Array.isArray(cart.items) ? cart.items : [];

    for (const it of items) {
      const p = it.properties || {};
      const designId = String(p._cm_design_id || "").trim();
      const itemEditUrl = String(p._cm_edit_url || p._cm_editor_url || p["_Editor URL"] || "").trim();
      if (designId && itemEditUrl) {
        editUrlByDesignId.set(designId, itemEditUrl);
      }
      if (designId) {
        const frontThumb = getCartThumbFromProps(p, "front");
        const backThumb = getCartThumbFromProps(p, "back");
        const recipe = decodeChunkedJson(p, "_CM Required Addons");
        if (frontThumb) thumbsByDesignId.set(designId, frontThumb);
        if (backThumb) backThumbByDesignId.set(designId, backThumb);
        if (Array.isArray(recipe) && recipe.length) recipeByDesignId.set(designId, recipe);
      }
    }

    for (const it of items) {
      const p = it.properties || {};
      const addonMeta = getAddonMeta(it, recipeByDesignId);
      if (addonMeta) {
        requiredAddonVariantIds.add(String(it.variant_id));
        const parentDesignId =
          addonMeta.parentDesignId ||
          String(p._cm_parent_design_id || "").trim() ||
          String(p._cm_design_id || "").trim();
        const addonKind = addonMeta.kind;
        const url =
          String(p._cm_edit_url || p._cm_editor_url || "").trim() ||
          editUrlByDesignId.get(parentDesignId) ||
          "";
        if (url) editorUrlByVariant.set(String(it.variant_id), url);
      }
    }

    latestRequiredAddonVariantIds = requiredAddonVariantIds;
    latestEditorUrlByVariant = editorUrlByVariant;
    latestCartItems = items;
    upsertEmptyCartButton();

    const els = cartItemElements();
    const itemByKey = new Map();
    items.forEach((item) => {
      const key = getItemKey(item);
      if (key) itemByKey.set(key, item);
    });

    const rowEntries = els
      .map((el, index) => {
        const lineItemKey =
          String(el.getAttribute("data-line-item-key") || "").trim() ||
          String(el.dataset.lineItemKey || "").trim();
        const item = itemByKey.get(lineItemKey) || items[index];
        return item ? { el, item } : null;
      })
      .filter(Boolean);

    const metaByKey = new Map();
    let previousMainDesignId = "";
    rowEntries.forEach(({ item }) => {
      const key = getItemKey(item);
      const mainDesignId = isMainDesignItem(item) ? getItemDesignId(item) : "";
      if (mainDesignId) {
        previousMainDesignId = mainDesignId;
        return;
      }

      const meta = getKnownAddonMeta(item, recipeByDesignId, previousMainDesignId);
      if (key && meta) metaByKey.set(key, meta);
    });

    protectRendering = true;
    try {
      applyGroupedCartOrder(rowEntries, metaByKey);

      const editableDesigns = [];
      const editableDesignIds = new Set();
      rowEntries.forEach(({ item }) => {
        const p = item.properties || {};
        if (!isMainDesignItem(item)) return;
        const mainDesignId = String(p._cm_design_id || "").trim();
        if (!mainDesignId || editableDesignIds.has(mainDesignId)) return;
        const editUrl =
          String(p._cm_edit_url || p._cm_editor_url || p["_Editor URL"] || "").trim() ||
          editUrlByDesignId.get(mainDesignId) ||
          "";
        if (!editUrl) return;
        editableDesignIds.add(mainDesignId);
        editableDesigns.push({
          designId: mainDesignId,
          editUrl: editUrl,
          title: String(item.product_title || item.product?.title || item.title || "Design")
        });
      });

      if (editableDesigns.length <= 1) cartEditSelectionMode = false;
      const showDesignSelectors = editableDesigns.length > 1 && cartEditSelectionMode;

      rowEntries.forEach(({ el, item }) => {
        const p = item.properties || {};
        const designId = String(p._cm_design_id || p._cm_parent_design_id || "").trim();
        const mainDesignId = isMainDesignItem(item) ? String(p._cm_design_id || "").trim() : "";
        if (designId) el.setAttribute("data-cm-design-id", designId);
        else el.removeAttribute("data-cm-design-id");
        if (mainDesignId) el.setAttribute("data-cm-main-design", "1");
        else el.removeAttribute("data-cm-main-design");
        const editUrl =
          String(p._cm_edit_url || p._cm_editor_url || p["_Editor URL"] || "").trim() ||
          editUrlByDesignId.get(designId) ||
          "";

        if (isDeliveryFeeItem(item)) {
          hideRemoveControls(el);
        }

        const addonMeta = metaByKey.get(getItemKey(item)) || getKnownAddonMeta(item, recipeByDesignId, "");
        if (addonMeta) {
          decorateRequiredAddonItem(el, editUrl);
          const addonKind = addonMeta.kind;
          const parentDesignId =
            addonMeta.parentDesignId ||
            String(p._cm_parent_design_id || "").trim() ||
            String(p._cm_design_id || "").trim();
          if (parentDesignId) {
            const thumbSide = getAddonThumbnailSide(item, addonKind);
            const fallbackThumb = thumbSide === "back"
              ? (backThumbByDesignId.get(parentDesignId) || thumbsByDesignId.get(parentDesignId) || "")
              : (thumbsByDesignId.get(parentDesignId) || backThumbByDesignId.get(parentDesignId) || "");
            const specificThumb = getAddonSpecificThumbnail(item, addonKind);
            const thumb = specificThumb || fallbackThumb;
            decorateAddonThumbnail(el, thumb, !!specificThumb, {
              backDesign: thumbSide === "back" && !specificThumb,
              portraitThumb: addonKind === "porcelain_portrait"
            });
          }
          return;
        }

        el.classList.remove("cm-required-addon");
        removeAddonNote(el);

        if (isMainDesignItem(item) && String(p._cm_design_id || "").trim() && editUrl) {
          decorateEditableMainItem(el, mainDesignId, editUrl, showDesignSelectors);
        } else {
          removeDesignSelector(el);
          removeEditButton(el);
        }

        if (mainDesignId) {
          if (thumbsByDesignId.get(mainDesignId)) {
            decorateMainThumbnail(el, item);
          } else {
            clearBackThumbBadge(el);
          }
        }
      });

      upsertCartEditControl(editableDesigns);
    } finally {
      window.requestAnimationFrame(() => {
        protectRendering = false;
      });
    }
  }

  function initCartProtection() {
    if (initCartProtection.done) return;
    initCartProtection.done = true;
    ensureCartStyles();
    ensureProtectBindings();
    protectOnce().catch((e) => console.warn("pamela-cart-protect:", e));
    scheduleProtect(800);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartProtection, { once: true });
  } else {
    initCartProtection();
  }
})();
